import React from "react";
import { ItemTypes, ItemWithMetaData } from "../../api/Items";

import AffiliationItem from "../../affiliation/AffiliationItem";
import {
  behaviorMap,
  BehaviorMappingActions,
  useFamaFlags,
} from "../../api/FamaFlags";
import PostsSummary from "../../posts/PostsSummary";
import { ReportSummaryItemApi } from "../../api/Reports";
import { justBehaviorRatings } from "../../system/helpers";
import AffiliationItemStats from "../../affiliation/AffiliationItemStats";
import PostsSummaryStats from "../../posts/PostsSummaryStats";

type Props = {
  categorySorted: (keyList: string[]) => string[];
  behaviorMappingActions: BehaviorMappingActions;
  postListCategory: { [key: string]: ItemWithMetaData[] };
  report: ReportSummaryItemApi;
};

const buildRatings = (
  item: ItemWithMetaData,
  behaviorMappingActions: BehaviorMappingActions
) =>
  justBehaviorRatings(item.rating).map((rating) => {
    return {
      ...rating,
      name: behaviorMap(rating.name, behaviorMappingActions, "key"),
      score_type: rating.score_type,
    };
  });

const ReportsSummaryPosts = ({
  categorySorted,
  behaviorMappingActions,
  postListCategory,
  report,
}: Props) => {
  return (
    <>
      {categorySorted(Object.keys(postListCategory)).map((key: string) => {
        return (
          <div key={key}>
            {key && key !== "NaN" && (
              <div
                key={key}
                className="w-full py-2 rounded-md bg-gray-100 font-semibold text-center"
              >
                {behaviorMap(key, behaviorMappingActions, "key")}
              </div>
            )}
            {postListCategory[key]?.map(
              (item: ItemWithMetaData, idx: number) => {
                return (
                  <PostSummaryItem
                    key={idx}
                    item={item}
                    report={report}
                    behaviorMappingActions={behaviorMappingActions}
                  />
                );
              }
            )}
          </div>
        );
      })}
    </>
  );
};

function PostSummaryItem({
  item,
  report,
  behaviorMappingActions,
}: {
  item: ItemWithMetaData;
  report: ReportSummaryItemApi;
  behaviorMappingActions: BehaviorMappingActions;
}) {
  const { useStatsInSummary } = useFamaFlags();
  if (!useStatsInSummary) {
    return (
      <>
        {item.type.name === ItemTypes.AFFILIATION ? (
          <AffiliationItem
            item={item}
            report={report}
            isReadOnly={true}
            isAmendment={true}
            handleAction={() => {}}
            behaviors={buildRatings(item, behaviorMappingActions).map(
              (rating) => rating.name
            )}
            hide={false}
          />
        ) : (
          <PostsSummary
            content={item.item.content}
            item={item}
            ratings={buildRatings(item, behaviorMappingActions)}
            source={item.source}
            keywords={item?.keywords?.length !== 0 ? item?.keywords : undefined}
          ></PostsSummary>
        )}
      </>
    );
  }
  return (
    <>
      {item.type.name === ItemTypes.AFFILIATION ? (
        <AffiliationItemStats
          item={item}
          report={report}
          isReadOnly={true}
          isAmendment={true}
          handleAction={() => {}}
          behaviors={buildRatings(item, behaviorMappingActions).map(
            (rating) => rating.name
          )}
          hide={false}
        />
      ) : (
        <PostsSummaryStats
          content={item.item.content}
          item={item}
          ratings={buildRatings(item, behaviorMappingActions)}
          source={item.source}
          keywords={item?.keywords?.length !== 0 ? item?.keywords : undefined}
        ></PostsSummaryStats>
      )}
    </>
  );
}

export default ReportsSummaryPosts;
